import React from "react";

import { Dialog } from "@/Components/v2/atoms/Dialog/Dialog";
import { DialogActions } from "@/Components/v2/atoms/Dialog/DialogActions";
import { DialogContent } from "@/Components/v2/atoms/Dialog/DialogContent";
import { DialogContentText } from "@/Components/v2/atoms/Dialog/DialogContentText";
import { Typography } from "@/Components/v2/atoms/Typography/Typography";

export interface ConfirmationProps {
  open: boolean;
  title: string;
  subtitle: string;
  primaryButtonText: string;
  secondaryButtonText: string;
  onPrimary: () => void;
  onSecondary: () => void;
  renderPrimaryButton: (props: { onClick: () => void; children: string }) => React.ReactElement;
  renderSecondaryButton: (props: { onClick: () => void; children: string }) => React.ReactElement;
}

export const Confirmation: React.FC<ConfirmationProps> = ({
  open,
  title,
  subtitle,
  primaryButtonText,
  secondaryButtonText,
  onPrimary,
  onSecondary,
  renderPrimaryButton,
  renderSecondaryButton,
}) => {
  const primaryButtonElement = renderPrimaryButton({
    onClick: onPrimary,
    children: primaryButtonText,
  });

  const secondaryButtonElement = renderSecondaryButton({
    onClick: onSecondary,
    children: secondaryButtonText,
  });

  return (
    <Dialog
      open={open}
      onClose={onSecondary}
      aria-labelledby="confirmation-dialog-title"
      aria-describedby="confirmation-dialog-description"
    >
      <DialogContent sx={{ padding: "1rem" }}>
        <DialogContentText id="confirmation-dialog-description" padding={2}>
          <Typography variant="h4" fontWeight={500} mb={2}>
            {title}
          </Typography>
          <Typography variant="body1">{subtitle}</Typography>
        </DialogContentText>
      </DialogContent>
      <DialogActions>
        <div style={{ marginRight: "1.5rem", marginBottom: "1.25rem" }}>
          {secondaryButtonElement}
          <span style={{ marginLeft: "1.5rem" }}>{primaryButtonElement}</span>
        </div>
      </DialogActions>
    </Dialog>
  );
};

export default Confirmation;
